/** A part of the app that fails shows what happened and a way out, instead of a blank page. */
import { Component, type ReactNode } from "react";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="mx-auto max-w-lg space-y-3 p-6 text-sm">
        <h2 className="text-base font-semibold">This part of BrainLog could not be shown</h2>
        <p className="text-muted-foreground">Your work is not affected. Reloading usually fixes it; if not, write to contact@brainlog.net with the message below.</p>
        <pre className="overflow-x-auto rounded bg-muted p-2 text-xs">{this.state.error.message}</pre>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    );
  }
}
